import React from 'react'
import agent from '../agent'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { store } from '../store'
import { push } from 'react-router-redux'
import ListErrors from './widgets/ListErrors'
import { Translation } from 'react-i18next'
import i18n from '../languages/lang.js'
import {
    FORGOTPASSWORD,
    CLEAR_REDIRECT,
    FORGOTPASSWORD_UNLOADED
} from '../constants/actionTypes'

const mapStateToProps = state => ({
    ...state.auth,
    inProgress: state.common.inProgress,
    currentUser: state.common.currentUser,
})

const mapDispatchToProps = dispatch => ({
    onSubmit: (payload) =>
        dispatch({ type: FORGOTPASSWORD, payload, redirectTo: 'verifyresetpassword' }),
    onRedirect: () =>
        dispatch({ type: CLEAR_REDIRECT }),
    onUnload: () => dispatch({ type: FORGOTPASSWORD_UNLOADED }),
})

class ResetPassword extends React.Component {
    constructor() {
        super()
        this.state = {
            email: '',
        }
        this.updateState = field => ev => {
            const state = this.state;
            const newState = Object.assign({}, state, { [field]: ev.target.value });
            this.setState(newState);
        }
        this.submitForm = (email) => ev => {
            ev.preventDefault()
            const payload = agent.Auth.forgotPassword(email)
            this.props.onSubmit(payload)
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.redirectTo) {
            store.dispatch(push(nextProps.redirectTo, { email: this.state.email }))
            this.props.onRedirect()
        }
    }
    componentWillUnmount() {
        this.props.onUnload()
    }

    render() {
        const email = this.state.email
        const inProgress = this.props.inProgress
        return (
            <Translation>
                {
                    (t) => (
                        <div id="focus">
                            <div id="focus-header"><h1>{t('system.name')}</h1></div>
                            <div className="main">
                                <div className="main-wrap">
                                    <div className="focus-wrap">
                                        <div className='box-header'>
                                            <h2>{t('authentication.reset_password_title')}</h2>
                                        </div>
                                        <div className="form-item">
                                            <label>{t('input_label.email')}</label>
                                            <input type="text" placeholder="Email" value={email} onChange={this.updateState('email')} />
                                        </div>
                                        <ListErrors errors={this.props.errors} />
                                        <div className="form-item">
                                            <button onClick={this.submitForm(email)}>{this.props.inProgress ? t('authentication.reset_button_progress') : t('authentication.reset_button')}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
            </Translation >
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword)
